import React, { Component } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Growl } from 'primereact/growl';
import { Message } from 'primereact/message';

import servicioHttp from '../servicio/ServicioHttp';
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioFormatos from '../servicio/ServicioFormatos';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';
const JOIN_PRINCIPAL = {
    "tcEmpresa": "alias_tcEmpresa",
    "ttUsuario": "alias_ttUsuario"};
const TODOS = { label: "Todos", value: 0 };

export class ConsultaRp extends Component {

    constructor() {
        super();
        this.state = {
            idsenube: 0,
            paginacion: {
                registrosPorPagina: 10,
                join: null,
                restriccionesDinamicas: [
                ]
            },
            registrosPatronales: [],
            registroPatronal: {},
            errorRegistroPatronal: {},
            consulta: {},
            errores: {},
            iFrameSrc: null,
            mostrarCalendarios: true
        }
    };
    componentDidMount() {
        this.obtenerRegistrosPatronales();
    }
    obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { consulta } = this.state;
            consulta.registroPatronal = TODOS;
            this.setState({ registrosPatronales: newArray, consulta: consulta });
        }).catch(error => {

        });
    };
    validarRequeridosForm = () => {
        let { consulta } = this.state;
        let errores = {};
        if (!servicioObjetos.esObjetoVacio(consulta.fechaInicio) && servicioObjetos.esObjetoVacio(consulta.fechaFinal))
            errores.fechaFinal = "La fecha final es requerida";
        if (servicioObjetos.esObjetoVacio(consulta.fechaInicio) && !servicioObjetos.esObjetoVacio(consulta.fechaFinal))
            errores.fechaInicio = "La fecha inicial es requerida";
    
        this.setState({ errores: errores });
        return errores;
    }
    realizarBusqueda = () => {
        let errores = this.validarRequeridosForm();
        let { paginacion, idsenube } = this.state;
        paginacion.numeroPagina = 0;
        idsenube = 0;
        this.setState({ idsenube: idsenube });
        if (servicioObjetos.esObjetoVacio(errores)) {
            this.asignarRestricciones();
            this.consultaMovimientos();
        }
    }
    asignarRestricciones = () => {
        let { consulta, paginacion } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [];
        if (!servicioObjetos.esObjetoVacio(consulta.registroPatronal)) {
            if (consulta.registroPatronal.value !== 0) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_tcEmpresa.id",
                    valorPropiedad: consulta.registroPatronal.value
                });
            }
        }
        if (!servicioObjetos.esObjetoVacio(consulta.fechaInicio) && !servicioObjetos.esObjetoVacio(consulta.fechaFinal)) {
            let fechaIncial = servicioFormatos.formatearFechaString(consulta.fechaInicio);
            let fechaFinal = servicioFormatos.formatearFechaString(consulta.fechaFinal).replace('00:00:00', '23:59:59');
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "between",
                nombrePropiedad: "fecha",
                valorPropiedad: null,
                fechaIncialBetween: fechaIncial,
                fechaFinalBetween: fechaFinal
            });
        }
       
       
        
    }
    consultaMovimientos = () => {
        this.asignarRestricciones();
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp('solicitud/consultar.json', paginacion).then(response => {
            this.setState({ paginacion: response.data.objeto });
        }).catch(error => {

        });
    }
    cambiaPagina = (event) => {
        this.asignarRestricciones();
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first });
        this.consultaMovimientos();
    }
    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }
    columnaFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fecha)}</div>;
      }
      columnaFechaRespuesta = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fechaRespuesta)}</div>;
      }
      columnaEstado = (rowData, column) => {
        if (rowData.estado === 0)
          return <div>Lote capturado</div>;
        if (rowData.estado === 1)
          return <div>Lote Enviado al IMSS</div>;
        if (rowData.estado === 2)
          return <div>Respuesta IMSS</div>;
      }

    render(){
        let { registrosPatronales, errorRegistroPatronal, consulta, errores, idsenube, paginacion,
             mostrarCalendarios } = this.state;
            let calendardioInicial = <div>
            <Calendar ref={(el) => this.calendario1 = el} id="consulta.fechaInicio" name="consulta.fechaInicio" value={consulta.fechaInicio || ''} onChange={(e) => this.asignarValores(e, false)} style={{ width: "100%" }} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX}></Calendar>
            {errores.fechaInicio ? <Message severity="error" text={errores.fechaInicio} /> : null}
        </div>;

        let calendardioFinal = <div>
            <Calendar id="consulta.fechaFinal" name="consulta.fechaFinal" value={consulta.fechaFinal || ''} onChange={(e) => this.asignarValores(e, false)} style={{ width: "100%" }} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX}></Calendar>
            {errores.fechaFinal ? <Message severity="error" text={errores.fechaFinal} /> : null}
        </div>;
        return(
            <div className="p-fluid">
                  <Growl ref={(el) => this.growl = el} />
                  <div className="p-grid">
                  <div className="p-col-12">
                  <div className="card">
                  <h1>Consulta por registro patronal</h1>
                  <div className="p-grid">
                                <div className="p-col-12 p-md-2">Registro Patronal:</div>
                                <div className="p-col-12 p-md-10"><Dropdown appendTo={document.body} id="consulta.registroPatronal" name="consulta.registroPatronal" optionLabel="label" options={registrosPatronales} value={consulta.registroPatronal} onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} className={errorRegistroPatronal.error ? "p-error" : ""} /></div>
                            </div>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-4 ">Fecha de transmisión:</div>
                                <div className="p-col-12 p-md-1 ">Entre:</div>
                                <div className="p-col-12 p-md-3 ">{mostrarCalendarios ? calendardioInicial : null}</div>
                                <div className="p-col-12 p-md-1 ">y:</div>
                                <div className="p-col-12 p-md-3">{mostrarCalendarios ? calendardioFinal : null}</div>
                            </div>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-2"><Button label="Limpiar" icon="pi-md-refresh" onClick={this.reiniciarFrmBusqueda} /></div>
                                <div className="p-col-12 p-md-2"><Button label="Buscar" icon="pi-md-search" onClick={this.realizarBusqueda} /></div>
                            </div>
                      </div>
                      </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                          
                            <DataTable value={paginacion.datos} header="Bitacora de movimientos" responsive={true} resizableColumns={true}>
                                <Column field="id" header="Num." style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="loteIdImss" header="LOTE IMSS" style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="estatus" header="ESTADO" style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="registroPatronal" header="REGISTRO PATRONAL" style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="usuario" header="USUARIO" style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="fecha" header="FECHA TRANSMISIÓN" style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                               
                            </DataTable>
                            <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} />
                        </div>
                    </div>

                </div>
                </div>
        )
    }
}